"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakdownTypes = void 0;
exports.BreakdownTypes = {
    Shipping: 'shipping',
    Tax: 'tax',
    Discount: 'discount',
    /**
     * @deprecated This field is deprecated and will be removed in a future version.
     * The itemsTotal is now calculated automatically from orderItems.
     * Please do not use this field when creating paymentBreakdown objects.
     */
    ItemsTotal: 'itemsTotal',
};
//# sourceMappingURL=PaymentBreakdown.js.map